module.exports = __webpack_public_path__ + "static/p9-263ff76e5e8f1f75a2ccec9270fdadf2.jpg";